import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { AuthProvider } from './contexts/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { enforceHttps } from './lib/https';

// Upgrade plain-http loads to HTTPS before booting the app.
enforceHttps();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
const root = ReactDOM.createRoot(container);
root.render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);

// Enable offline support and asset caching via the service worker.
serviceWorkerRegistration.register();
